/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const auxiliaryRoutes = {
  component: Layout,
  redirect: 'noredirect',
  name: 'Auxiliary',
  alwaysShow: true,
  meta: {
    title: '辅助工具',
    permissions: 'auxiliary',
    icon: 'ali-tool',
  },
  children: [
    //   素材库
    {
      /** 路由地址 */
      /** 文件路径 */
      component: () => import('@/views/auxiliary/material-library/index'),
      /** 路由名称 */
      name: 'MaterialLibrary',
      /** 左边导航 */
      meta: { title: '素材库', permissions: 'auxiliary-material-library', icon: 'ali-material' },
      /** 子页面 */
      children: [
        {
          component: () => import('@/views/auxiliary/material-library/material-upload/index'),
          name: 'UploadMaterial',
          meta: { title: '上传素材', permissions: 'material-upload', icon: 'ali-material' },
        },
        {
          component: () => import('@/views/auxiliary/material-library/material-list/index'),
          name: 'MaterialList',
          meta: { title: '素材列表', permissions: 'material-list', icon: 'ali-material' },
        }, {
          component: () => import('@/views/auxiliary/material-library/material-format/index'),
          name: 'MaterialFormat',
          meta: { title: '素材规格', permissions: 'material-format', icon: 'ali-material' },
        },
        {
          component: () => import('@/views/auxiliary/material-library/material-tags/index'),
          name: 'MaterialTags',
          meta: { title: '素材标签库', permissions: 'material-tags', icon: 'ali-material' },
        },
      ],
    },
    // 批量工具
    {
      component: () => import('@/views/auxiliary/batch-tool'),
      name: 'BatchTool',
      meta: { title: '批量工具', permissions: 'batch-tool', icon: 'example' },
      children: [
        {
          component: () => import('@/views/auxiliary/batch-tool'),
          name: 'NativeAnchor',
          meta: { title: '原生锚点', permissions: 'batch-tool-native-anchor', icon: 'example' },
          children: [
            {
              component: () => import('@/views/auxiliary/batch-tool/source-template'),
              name: 'NativeAnchorJrtt',
              meta: { title: '原生锚点-头条', permissions: 'batch-tool-native-anchor-jrtt', icon: 'example' },
            },
          ],
        },
        {
          component: () => import('@/views/auxiliary/batch-tool'),
          name: 'Site',
          meta: { title: '落地页', permissions: 'batch-tool-site', icon: 'example' },
          children: [
            {
              component: () => import('@/views/auxiliary/batch-tool/source-template'),
              name: 'SiteJrtt',
              meta: { title: '落地页-头条', permissions: 'batch-tool-site-jrtt', icon: 'example' },
            },
          ],
        },
        {
          component: () => import('@/views/auxiliary/batch-tool/batch-create-log'),
          name: 'BatchCreateLog',
          meta: { title: '批量操作记录', permissions: 'batch-create-log', icon: 'example' },
        },
      ],
    },
    /** 标题库 */
    {
      component: () => import('@/views/auxiliary/title/index'),
      name: 'TitleList',
      meta: { title: '标题库', permissions: 'title-list', icon: 'ali-title' },
      children: [
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'JrttTitle',
          meta: { title: '标题库-头条', permissions: 'title-list-jrtt', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'GdtTitle',
          meta: { title: '标题库-广点通', permissions: 'title-list-gdt', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'BaiduTitle',
          meta: { title: '标题库-百度', permissions: 'title-list-baidu', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'BilibiliTitle',
          meta: { title: '标题库-B站', permissions: 'title-list-bilibili', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'HuaWeiTitle',
          meta: { title: '标题库-华为', permissions: 'title-list-huawei', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'OppoTitle',
          meta: { title: '标题库-OPPO', permissions: 'title-list-oppo', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'VivoTitle',
          meta: { title: '标题库-VIVO', permissions: 'title-list-vivo', icon: 'ali-title' },
        },
        {
          component: () => import('@/views/auxiliary/title'),
          name: 'XiaoMiTitle',
          meta: { title: '标题库-小米', permissions: 'title-list-xiaomi', icon: 'ali-title' },
        },
      ],
    },
    // 转化跟踪
    {
      component: () => import('@/views/auxiliary/tracking/index'),
      name: 'TrackingList',
      meta: { title: '转化跟踪', permissions: 'tracking', icon: 'ali-transformation' },
      children: [
        /** 今日头条转化跟踪 */
        {
          component: () => import('@/views/auxiliary/tracking/jrtt/index'),
          name: 'JrttTracking',
          meta: { title: '转化跟踪-头条', permissions: 'tracking-jrtt', icon: 'ali-transformation' },
        },
        /** 广点通转化跟踪 */
        {
          component: () => import('@/views/auxiliary/tracking/gdt/index'),
          name: 'gdtTracking',
          meta: { title: '转化跟踪-广点通', permissions: 'tracking-gdt', icon: 'ali-transformation' },
        },
      ],
    },
    // 分包工具
    {
      component: () => import('@/views/auxiliary/extend-package/index'),
      name: 'ExtendPackageList',
      meta: { title: '分包工具', permissions: 'extend-package', icon: 'ali-transformation' },
      alwaysShow: true,
      children: [
        /** 分包工具-广点通 */
        {
          component: () => import('@/views/auxiliary/extend-package/gdt/index'),
          name: 'GdtExtendPackage',
          meta: { title: '分包工具-广点通', permissions: 'extend-package-gdt', icon: 'ali-transformation' },
        },
      ],
    },
  ],
};

export default auxiliaryRoutes;
